










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ExpansionPanel from '@/shared/components/expansion.panel.component.vue';
import Ship from '@/shared/components/ship.component.vue';
import SwitchButton from '@/shared/components/switch.component.vue';
import Btn, { BtnColor } from '@/shared/components/btn.component.vue';
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
} from '@/shared/components/FlatSelectorText.component.vue';
import Field from '@/shared/components/field.component.vue';
import Datepicker, { DatepickerBorder } from '@/shared/components/datepicker/index.vue';

import { mapGetters } from 'vuex';

// Model
import { Client, ClientFilter as ClientModel } from '@/manager/client/client.model';

// Constant
import Input, { InputType } from '@/shared/components/input.component.vue';
import UtilsService from '@/core/services/utils.service';

// Third party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

@Component({
  components: {
    ExpansionPanel,
    Ship,
    Input,
    SwitchButton,
    Btn,
    FlatSelectorText,
    Field,
    Datepicker
  },
  computed: {
    ...mapGetters({
      getProcedencyList: 'procedencyList',
      getTagList: 'clientTagList',
      genderFilter: 'getGenderFilter',
      locationFilter: 'getLocationFilter',
      procedencyFilter: 'getProcedencyFilter',
      levelUpDataFilter: 'getLevelUpDataFilter',
      curseFilter: 'getCurseFilter',
      conferenceFilter: 'getConferenceFilter',
      eventsFilter: 'getEventsFilter',
      tagsFilter: 'getTagsFilter',
      fiscalDataFilter: 'getFiscalDataFilter',
      clientDateFilter: 'getClientDateFilter',
      setProcedencyFilter: 'setProcedencyFilter',
      setGenderFilter: 'setGenderFilter',
      setLevelUpDataFilter: 'setLevelUpDataFilter',
      setCurseFilter: 'setCurseFilter',
      setEventsFilter: 'setEventsFilter',
      setTagsFilter: 'setTagsFilter',
      setConferenceFilter: 'setConferenceFilter',
      setLocationFilter: 'setLocationFilter',
      setFiscalDataFilter: 'setFiscalDataFilter',
      setClientDateFilter: 'setClientDateFilter',
    }),
  },
})
export default class ClientFilter extends Vue {
  @Prop() private id!: string;
  @Prop({ default: false }) private filterState!: boolean;

  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private datepickerBorder = DatepickerBorder;
  private dateFrom = null;
  private dateTo = null;


  private gender: Filter = new Filter();
  private procedency: Filter = new Filter();
  private location: Filter = new Filter();
  private levelUpData: Filter = new Filter();
  private curse: Filter = new Filter();
  private events: Filter = new Filter();
  private tags: Filter = new Filter();
  private conference: Filter = new Filter();
  private fiscalData: Filter = new Filter();
  private clientDate: Filter = new Filter();

  private genderFilter!: Filter;
  private locationFilter!: Filter;
  private procedencyFilter!: Filter;
  private levelUpDataFilter!: Filter;
  private curseFilter!: Filter;
  private conferenceFilter!: Filter;
  private eventsFilter!: Filter;
  private tagsFilter!: Filter;
  private fiscalDataFilter!: Filter;
  private clientDateFilter!: Filter;

  private inputType = InputType;
  private btnColor = BtnColor;
  private getProcedencyList!: any;
  private getTagList!: any;
  private delegationList!: any;
  private locationList: any = [];
  private courseList: any = [];
  private conferenceList: any = [];
  private eventsList: any = [];

  get defaultDate() {
    const today = dayjs().toISOString();
    const from = dayjs().set('date', 1).set('month', 0).toISOString();
    return {
      from,
      to: today,
    };
  }

  private dateRangeSelected(from: any, to: any) {
    if (from && to) {
      const dateFrom = UtilsService.setTimeToCero(dayjs(from)).toISOString();
      const dateTo = UtilsService.setTimeToLast(dayjs(to)).toISOString();

      this.dateFrom = dateFrom;
      this.dateTo = dateTo;
    } else {
      this.dateFrom = null;
      this.dateTo = null;
    }

  }

  @Watch('allFilters')
  watchAllFilters(newVal: any) {
    this.filters.forEach((filter) => {
      this.handleWatchedFilter(
        !!filter.inputs || !!filter.ships,
        (filter as any).storeMutationName,
        filter,
      );
    });
  }

  private handleWatchedFilter(
    active: boolean | undefined,
    type: string,
    filter: Filter,
  ) {
    if (active) {
      this.$store.dispatch(type, filter);
      this.updateFilters();
    }
  }

  private search() {
    this.$emit('search');
  }

  private created() {
    this.fetchGender();
    this.fetchProcedency();
    this.fetchDelegationList();
    this.fetchLocationList();
    this.fetchLevelUpData();
    this.fetchCoursesList();
    this.fetchEventsList();
    this.fetchConferenceList();
    this.fetchCourse();
    this.fetchEvents();
    this.fetchTags();
    this.fetchConference();
    this.fetchLocation();
    this.fetchFiscalData();
    this.fetchClientDate();
  }

  private updateFilters(who?: string) {
    this.$emit('filter-object', this.allFilters);
  }

  private reserFilters(){
    this.$store.dispatch("setProcedencyFilter", new ClientModel())
    this.$store.dispatch("setGenderFilter", new ClientModel())
    this.$store.dispatch("setLevelUpDataFilter", new ClientModel())
    this.$store.dispatch("setCurseFilter", new ClientModel())
    this.$store.dispatch("setEventsFilter", new ClientModel())
    this.$store.dispatch("setTagsFilter", new ClientModel())
    this.$store.dispatch("setConferenceFilter", new ClientModel())
    this.$store.dispatch("setLocationFilter", new ClientModel())
    this.$store.dispatch("setFiscalDataFilter", new ClientModel())
    this.$store.dispatch("setClientDateFilter", new ClientModel())

    this.fetchGender();
    this.fetchProcedency();
    this.fetchDelegationList();
    this.fetchLocationList();
    this.fetchLevelUpData();
    this.fetchCoursesList();
    this.fetchEventsList();
    this.fetchConferenceList();
    this.fetchCourse();
    this.fetchEvents();
    this.fetchTags();
    this.fetchConference();
    this.fetchLocation();
    this.fetchFiscalData();
    this.fetchClientDate();
  }

  get syncedFilterState() {
    return this.filterState;
  }

  set syncedFilterState(value) {
    this.$emit('update:filterState', value);
  }

  get allFilters() {
    const obj = {
      ...this.buildFieldFilter(this.gender, 'user__profile__gender'),
      ...this.buildFieldFilter(this.procedency, 'procedency__id'),
      ...this.buildFieldFilter(this.tags, 'tag__id'),
      ...this.buildLevelUpDataFilter(),
      ...this.buildProductSelectFilter(),
      ...this.buildLocationFilter(),
      ...this.buildFiscalDataFilter(),
      ...this.buildClientDateFilter(),

    };
    Object.keys(obj).forEach(
      (key) => obj[key] === undefined && delete obj[key],
    );
    return obj;
  }

  get searchDisabled() {
    return Object.keys(this.allFilters).length === 0;
  }

  buildFieldFilter(field: Filter, fieldName: string) {
    if (!field.active) {
      return null;
    }
    const item: any = {};
    item[fieldName] = '';
    if (field.ships) {
      (field.ships as Array<any>)
        .filter((e: any) => e.active)
        .forEach((e: any) => {
          item[fieldName] += item[fieldName].length === 0 ? e.id : ',' + e.id;
        });
    }
    return item[fieldName].length > 0 ? item : null;
  }

  buildProductSelectFilter() {
    const courses = this.buildProductSelectFilterByTag('curse');
    const events = this.buildProductSelectFilterByTag('events');
    const conferences = this.buildProductSelectFilterByTag('conference');
    return {
      courses,
      events,
      conferences,
    };
  }

  buildProductSelectFilterByTag(tag: string): string | undefined {
    let delegation, location, state, product;
    const currentProduct = (this as any)[tag],
      selects = currentProduct.selects as Array<any>;

    if (currentProduct.active) {
      const locationItem = selects.find((e: any) => e.options === 'location');
      const delegationItem = selects.find(
        (e: any) => e.options === 'delegation',
      );
      const productItem = selects.find((e: any) => e.options === tag);

      if (delegationItem.model.value && delegationItem.model.value !== '0') {
        delegation = delegationItem.model.value;
      }
      if (
        locationItem &&
        locationItem.model.value &&
        locationItem.model.value !== '0'
      ) {
        location = locationItem.model.value;
      }

      if (productItem.model.value && productItem.model.value !== '0') {
        product = productItem.model.value;
      }
    }
    state = this.buildFieldFilter(currentProduct, 'state');
    const obj = {
      delegation,
      location,
      product,
      ...state,
    };
    Object.keys(obj).forEach(
      (key) => obj[key] === undefined && delete obj[key],
    );
    return UtilsService.objectIsEmpty(obj) ? undefined : JSON.stringify(obj);
  }

  buildLevelUpDataFilter() {
    if (!this.levelUpData.active) {
      return null;
    }
    try {
      const obj: any = {};

      const statusList: Array<string> = [];
      const certificationList: Array<string> = [];

      (this.levelUpData.ships as Array<any>)
        .filter((e: any) => e.active)
        .forEach((e: any) => {
          if (typeof e.value === 'boolean') {
            obj[e.label] = e.value;
          } else if (e.label === 'certifications') {
            certificationList.push(e.value)
          } else {
            statusList.push(e.value)
          }

        });

      const status = statusList.length > 0 ? { status: statusList.toString() } : {};
      const certifications = certificationList.length > 0 ? { certifications: certificationList.toString() } : {};

      return { ...obj, ...status, ...certifications };
    } catch (_) {
      return {};
    }
  }

  buildLocationFilter() {
    try {
      const province: any = (this.location.inputs as Array<any>)
        .filter((e: any) => e.label === 'Provincia' && !!e.value)
        .map((e: any) => e.value)
        .toString();

      const locality: any = (this.location.inputs as Array<any>)
        .filter((e: any) => e.label === 'Localidad' && !!e.value)
        .map((e: any) => e.value)
        .toString();

      const obj: any = {
        user__profile__state: province ? province : undefined,
        user__profile__town: locality ? locality : undefined,
      };
      return obj;
    } catch (_) {
      return {};
    }
  }

  buildFiscalDataFilter() {
    try {
      const nif: any = (this.fiscalData.inputs as Array<any>)
        .filter((e: any) => e.label === 'DNI' && !!e.value)
        .map((e: any) => e.value)
        .toString();

      const first_name: any = (this.fiscalData.inputs as Array<any>)
        .filter((e: any) => e.label === 'Nombre empresa' && !!e.value)
        .map((e: any) => e.value)
        .toString();


      const obj: any = {
        fiscal_data_extension__nif: nif ? nif : undefined,
        fiscal_data_extension__first_name: first_name ? first_name : undefined,
      };
      return obj;
    } catch (_) {
      return {};
    }
  }
  
  buildClientDateFilter() {
    try {
      const obj: any = {
        dateFrom: this.dateFrom ? this.dateFrom : undefined,
        dateTo: this.dateTo ? this.dateTo : undefined,
      };
      return obj;
    } catch (_) {
      return {};
    }
  }

  get filters(): Array<Filter> {
    return [
      this.gender,
      this.location,
      this.procedency,
      this.levelUpData,
      this.curse,
      this.conference,
      this.events,
      this.tags,
      this.fiscalData,
      this.clientDate,
    ];
  }

  private fetchDelegationList() {
    return this.$store.dispatch('fetchDelegationList').then((res) => {
      this.delegationList = res.results.map((delegation: any) => {
        return {
          value: delegation.id,
          label: delegation.name,
        };
      });
    });
  }

  private fetchLocationList() {
    return this.$store.dispatch('fetchLocationList').then((res) => {
      this.locationList = res.results.map((delegation: any) => {
        return {
          value: delegation.id,
          label: delegation.name,
        };
      });
    });
  }

  private fetchEventsList() {
    this.fetchProductList('event').then((res) => {
      this.eventsList = res;
    });
  }

  private fetchCoursesList() {
    this.fetchProductList('course').then((res) => {
      this.courseList = res;
    });
  }

  private fetchConferenceList() {
    this.fetchProductList('conference').then((res) => {
      this.conferenceList = res;
    });
  }

  private fetchProductList(type: string) {
    const payload = {
      type_of_product: type,
    };
    return this.$store.dispatch('fetchProductList', payload).then(
      (res) => {
        return res.results.map((item: any) => {
          return {
            value: item.id,
            label: item.name,
          };
        });
      },
      (err) => {
        console.error('fetch courses fail', err);
        return [];
      },
    );
  }

  private getSelectList(type: string) {
    switch (type) {
      case 'curse':
        return this.courseList;
      case 'delegation':
        return this.delegationList;
      case 'conference':
        return this.conferenceList;
      case 'location':
        return this.locationList;
      case 'events':
        return this.eventsList;
    }
  }

  private fetchProcedency() {
    if (this.procedencyFilter.active) {
      this.procedency = this.procedencyFilter;
    } else {
      this.$store.dispatch('fetchProcedency').then((res) => {
        const ships = this.getProcedencyList.map((e: any) => {
          return {
            active: false,
            text: e.name,
            id: e.id,
          };
        });
        this.procedency = {
          panelText: 'Origen LEVEL UP',
          active: false,
          type: 'ship',
          storeMutationName: 'setProcedencyFilter',
          ships,
        } as Filter;
      });
    }
  }

  private fetchGender(): void {
    if (this.genderFilter.active) {
      this.gender = this.genderFilter;
    } else {
      this.gender = {
        panelText: 'Género',
        active: false,
        storeMutationName: 'setGenderFilter',
        type: 'ship',
        ships: [
          {
            active: false,
            id: 1,
            text: 'Hombre',
          },
          {
            active: false,
            id: 2,
            text: 'Mujer',
          },
          {
            active: false,
            id: 0,
            text: 'No especificado',
          },
        ],
        inputs: [],
      } as Filter;
    }
  }

  private fetchLevelUpData(): void {
    if (this.levelUpDataFilter.active) {
      this.levelUpData = this.levelUpDataFilter;
    } else {
      this.levelUpData = {
        panelText: 'Datos LEVEL UP',
        active: false,
        storeMutationName: 'setLevelUpDataFilter',
        type: 'ship',
        ships: [
          {
            active: false,
            value: 'tlp',
            text: 'Top Level Pack',
            label: 'certifications',
            id: 0,
          },
          {
            active: false,
            value: 'pwp',
            text: 'Power Pack',
            label: 'certifications',
            id: 0,
          },
          {
            active: false,
            value: 'cn3',
            text: 'Certificado Nivel 3',
            label: 'certifications',
            id: 1,
          },
          {
            active: false,
            value: true,
            text: 'Afiliado',
            label: 'affiliate',
            id: 2,
          },
          {
            active: false,
            value: 2,
            text: 'Cliente',
            label: 'status',
            id: 3,
          },
          {
            active: false,
            value: 1,
            text: 'Potencial',
            label: 'status',
            id: 4,
          },
        ],
        inputs: [],
      } as Filter;
    }
  }

  private fetchCourse(): void {
    if (this.curseFilter.active) {
      this.curse = this.curseFilter;
    } else {
      const selects = [
        {
          fieldLabel: 'Curso',
          fieldClass: '1/2',
          initialOption: {},
          options: 'curse',
          placeholder: 'Curso',
          model: {},
        },
        {
          fieldLabel: 'Delegación',
          fieldClass: '1/2',
          initialOption: {},
          options: 'delegation',
          placeholder: 'Delegación',
          model: {},
        },
      ];
      this.curse = {
        panelText: 'Curso',
        active: false,
        storeMutationName: 'setCurseFilter',
        type: 'ship',
        ships: [
          {
            active: false,
            text: 'No adquirido',
            id: 0,
          },
          {
            active: false,
            text: 'Inscrito',
            id: 1,
          },
          {
            active: false,
            text: 'Cursado',
            id: 2,
          },
          {
            active: false,
            text: 'Bajas',
            id: 3,
          },
        ],
        inputs: [],
        selects,
      } as Filter;
    }
  }

  private fetchEvents(): void {
    if (this.eventsFilter.active) {
      this.events = this.eventsFilter;
    } else {
      const selects = [
        {
          fieldLabel: 'Eventos',
          fieldClass: '1/3',
          initialOption: {},
          options: 'events',
          placeholder: 'Eventos',
          model: {},
        },
        {
          fieldLabel: 'Delegación',
          fieldClass: '1/3',
          initialOption: {},
          options: 'delegation',
          placeholder: 'Delegación',
          model: {},
        },
        {
          fieldLabel: 'Localidad',
          fieldClass: '1/3',
          initialOption: {},
          options: 'location',
          placeholder: 'Localidad',
          model: {},
        },
      ];
      this.events = {
        panelText: 'Evento',
        active: false,
        storeMutationName: 'setEventsFilter',
        type: 'ship',
        ships: [
          {
            active: false,
            text: 'No adquirido',
            id: 0,
          },
          {
            active: false,
            text: 'Inscrito',
            id: 1,
          },
          {
            active: false,
            text: 'Cursado',
            id: 2,
          },
          {
            active: false,
            text: 'Bajas',
            id: 3,
          },
        ],
        inputs: [],
        selects,
      } as Filter;
    }
  }

  private fetchTags(): void {
    if (this.tagsFilter.active) {
      this.tags = this.tagsFilter;
    } else {
      this.$store.dispatch('fetchClientTagList').then((res) => {
        const ships = this.getTagList.map((e: any) => {
          return {
            active: false,
            text: e.name,
            id: e.id,
          };
        });
        this.tags = {
          panelText: 'Etiquetas',
          storeMutationName: 'setTagsFilter',
          active: false,
          type: 'ship',
          ships,
        } as Filter;
      });
    }
  }

  private fetchConference(): void {
    if (this.conferenceFilter.active) {
      this.conference = this.conferenceFilter;
    } else {
      const selects = [
        {
          fieldLabel: 'Conferencias',
          fieldClass: '1/3',
          initialOption: {},
          options: 'conference',
          placeholder: 'Conferencias',
          model: {},
        },
        {
          fieldLabel: 'Delegación',
          fieldClass: '1/3',
          initialOption: {},
          options: 'delegation',
          placeholder: 'Delegación',
          model: {},
        },
        {
          fieldLabel: 'Localidad',
          fieldClass: '1/3',
          initialOption: {},
          options: 'location',
          placeholder: 'Localidad',
          model: {},
        },
      ];
      this.conference = {
        panelText: 'Conferencia',
        storeMutationName: 'setConferenceFilter',
        active: false,
        type: 'ship',
        ships: [
          {
            active: false,
            text: 'No adquirido',
            id: 0,
          },
          {
            active: false,
            text: 'Inscrito',
            id: 1,
          },
          {
            active: false,
            text: 'Cursado',
            id: 2,
          },
          {
            active: false,
            text: 'Bajas',
            id: 3,
          },
        ],
        inputs: [],
        selects,
      } as Filter;
    }
  }

  private fetchLocation(): void {
    if (this.locationFilter.inputs) {
      this.location = this.locationFilter;
    } else {
      this.location = {
        panelText: 'Localización',
        storeMutationName: 'setLocationFilter',
        type: 'input',
        chips: [],
        inputs: [
          {
            value: '',
            label: 'Provincia',
            placeholder: 'Escribe una provincia',
          },
          {
            value: '',
            label: 'Localidad',
            placeholder: 'Escribe una localidad',
          },
        ],
        selects: [],
      } as Filter;
    }
  }

  private fetchFiscalData(): void {
    if (this.fiscalDataFilter.inputs) {
      this.fiscalData = this.fiscalDataFilter;
    } else {
      this.fiscalData = {
        panelText: 'Datos fiscales',
        storeMutationName: 'setFiscalDataFilter',
        type: 'input',
        chips: [],
        inputs: [
          {
            value: '',
            label: 'DNI',
            placeholder: 'Escribe un DNI',
          },
          {
            value: '',
            label: 'Nombre empresa',
            placeholder: 'Escribe un nombre de empresa',
          },
        ],
        selects: [],
      } as Filter;
    }
  }

  private fetchClientDate(): void {
    if (this.clientDateFilter.inputs) {
      this.clientDate = this.clientDateFilter;
    } else {
      this.clientDate = {
        panelText: 'Fecha creación',
        storeMutationName: 'setClientDateFilter',
        type: 'input',
        chips: [],
        inputs: [
          // {
          //   value: '',
          //   label: 'Fecha',
          //   placeholder: 'Escribe una fecha',
          // },
        ],
        selects: [],
      } as Filter;
    }
  }

  private updateFilterInput(inputs: Array<any>, index: number): void {
    setTimeout(() => {
      const currentInput = inputs[index];
      const hasValue = currentInput.value;
      const hasNext = !!inputs[index + 1];
      const nextItDifferentType = hasNext
        ? inputs[index + 1].label !== currentInput.label
        : true;

      if (hasValue && nextItDifferentType) {
        inputs = inputs.splice(index + 1, 0, {
          value: '',
          label: currentInput.label,
          placeholder: currentInput.placeholder,
        });
      } else if (hasNext && !nextItDifferentType && !hasValue) {
        inputs.splice(index, 1);
      }
      this.updateFilters();
    });
  }
}

// filter model
interface FilterInterface {
  panelText: string;
  type?: 'input' | 'ship';
  active?: boolean;
  inputs?: any[];
  ships?: any[];
  selects?: any[];
}

class Filter implements FilterInterface {
  public panelText!: string;
  public type?: 'input' | 'ship';
  public active?: boolean;
  public inputs?: any[];
  public ships?: any[];
  public selects?: any[];

  constructor() {
    this.type = 'ship';
    this.active = false;
  }
}
